var com = {};
export default com;

/**
 * 复制对象
 * @param {*} target 原对象
 * @return {*} 清理地址关联后的复制对象
 * 原对象禁止循环嵌套
 */
com.clearObject = (target={}) =>{
	return JSON.parse( JSON.stringify( target ) );
};
export const clearObject = com.clearObject;

/**
 * 格式化价格 
 * 重写 toFixed
 * 因为 toFixed : 四舍六入五考虑，五后非零就进一，五后皆零看奇偶，五前为偶应舍去，五前为奇要进一
 * 优化方式
 * *(10^保留位数) 比如保留位数2, 1.335 * 100 = 133.5
 * +0.5 原始四舍五入 比如 133.5 + 0.5 = 134
 * 舍小数点取整 比如 134 = 34
 * /(10^保留位数) 把数还原回去 比如 134/100 = 1.34
 * 最终解决了 (1.335).toFixed(2) = "1.33" 不精准的问题 
 * 与 toFixed 不同的是返回 Number.
 * @param Number price 原价格
 * @return Number 处理后的价格
 */
com.computePrice = (price=0,n=2)=> {
	if(isNaN(price)){return 0;}
	else {
		var x = Math.pow(10, n);
		if(price==0){
			return 0;
		}else if(price>0){
			return parseInt((price*x)+0.5)/x;
		}else{
			return parseInt((price*x)-0.5)/x;
		}
	}
}
export const computePrice = com.computePrice;
/**
 * 格式化时间
 * @param {*} fmt 格式,默认 yyyy-MM-dd hh:mm:ss
 * @param {*} date Date对象,不传则为当前时间
 */
com.dateFormat = (fmt='yyyy-MM-dd hh:mm:ss',date=new Date())=>{
	var o = {
		"M+" : date.getMonth() + 1,
		"d+" : date.getDate(),
		"h+" : date.getHours(),
		"m+" : date.getMinutes(),
		"s+" : date.getSeconds(),
		"q+" : Math.floor((date.getMonth() + 3) / 3),
		"S" : date.getMilliseconds()
	};

	if (/(y+)/.test(fmt))
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (var k in o){
		if (new RegExp("(" + k + ")").test(fmt)){
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		}
	}
	return fmt;
}
export const dateFormat = com.dateFormat;



// WEBPACK FOOTER //
// ./../../plugins/utils/common.js